import { computed, type MaybeRefOrGetter } from 'vue';
import { useEquipmentQuery } from './useEquipmentQuery';
import { date } from '/@utilities/intl';

export function useEquipmentInfo(guid: MaybeRefOrGetter<string>) {
  const { data: equipment, isPending: equipmentLoading } = useEquipmentQuery(guid);

  const equipmentInfo = computed(
    (): Array<{ label: string; value: string | null; large?: boolean }> => {
      const e = equipment.value;
      if (!e) return [];

      return [
        {
          label: 'Kontrollsyklus',
          value: e.MaintenanceCycle ? `${e.MaintenanceCycle} måneder` : null,
        },
        {
          label: 'Neste Kontrolldato',
          value: date(e.NextMaintenanceDate),
        },
        { label: 'Ute av drift', value: e.OutOfCommision ? 'Ja' : 'Nei' },
        { label: 'Kondemnert', value: e.IsCondemned ? 'Ja' : 'Nei' },
        { label: 'Beskrivelse', value: e.Description, large: true },
      ];
    },
  );

  return { equipmentInfo, equipmentLoading };
}
